import { 
    GET_POST_REQUEST,
    GET_POST_SUCCESS,
    GET_POST_FAILURE
 } from '../constant/actionTypes';

export const getPost = payload => ({
    type: GET_POST_REQUEST,
    payload,
});

export const getPostSuccess = payload => ({
    type: GET_POST_SUCCESS,
    payload,
});

export const getPostFailure = payload => ({
    type: GET_POST_FAILURE,
    payload,
});